export const PREMIUM_PAGE_URL =
  "https://www.geeksforgeeks.org/geeksforgeeks-premium-subscription";

export const THREE_NINETY_PAYMENTS_URL = "https://www.geeksforgeeks.org/courses?itm_source=geeksforgeeks/payments&itm_medium=topBanner&itm_campaign=three90";

export const USER_THEME = {
  LIGHT: "light",
  DARK: "dark",
};
